import { GetDepositPromotionNamesForSelectorResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { getDepositPromotionNamesForSelectorChannel } from '../../services'

export default function useQueryGetDepositPromotionNamesForSelectorChannel(
	props?: UseBaseQueryOptions<GetDepositPromotionNamesForSelectorResponse>,
) {
	return useQuery({
		queryKey: [
			DepositPromotionQueryKeys.GetDepositPromotionNamesForSelectorChannel,
		],
		queryFn: () => getDepositPromotionNamesForSelectorChannel(),
		...props,
	})
}
